/**
 * @file The action component allows users, particularly on mobile devices, to accept a demand on the marketplace in the detail view
 * @author Maarten Lensink
 */
import * as tslib_1 from "tslib";
import { Entity, EntityQuery, FetchStrategy, QueryOptions } from 'breeze-client';
import * as moment from 'moment';
import { OverlayProvider } from '../../ui/overlay-provider';
import { LocalisationService } from '../../core/localisation.service';
import { OverlayService } from '../../core/overlay.service';
import { DomainService } from '../../domain.service';
import { AlertsService } from '../../core/alerts.service';
import { ResourceService } from '../../resource.service';
import { AbstractBase } from '../../core/helpers/abstract-base';
var AcceptDemandComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AcceptDemandComponent, _super);
    /**
     * Creates an instance of AcceptDemandComponent.
     * @param {ActivatedRoute} route The route contains the entity key
     * @param {DomainService} domainService The domain service is used to retrieve the entity
     */
    function AcceptDemandComponent(resourceService, overlayProvider, overlayService, localisationService, domainService, alertsService) {
        var _this = _super.call(this) || this;
        _this.resourceService = resourceService;
        _this.overlayService = overlayService;
        _this.localisationService = localisationService;
        _this.domainService = domainService;
        _this.alertsService = alertsService;
        _this.entity = overlayProvider.entity;
        return _this;
    }
    /**
     * Returns a string representation of the date component of the parameter
     * @param {Date} date The date to be displayed
     * @returns The date in localised string format
     */
    AcceptDemandComponent.prototype.dateFormat = function (date) {
        return moment(date).format(this.localisationService.date.format);
    };
    /**
     * Returns a string representation of the time component of the parameter
     * @param {Date} date The date whose time is displayed
     * @returns The time in localised string format
     */
    AcceptDemandComponent.prototype.timeFormat = function (date) {
        return moment(date).format(this.localisationService.time.format);
    };
    /**
     * Converts an ISO 8601 duration string into a readable string
     * @param value The value to be parsed
     * @return An "h:mm" formatted string
     */
    AcceptDemandComponent.prototype.durationToString = function (value) {
        if (!value) {
            return '0:00';
        }
        var duration = moment.duration(value);
        return Math.floor(duration.asHours()) + ':' + ('0' + duration.minutes()).slice(-2);
    };
    /**
     * Finds the first available deployment, links the resource and plans it
     * @param {any} event The button that is pressed
     */
    AcceptDemandComponent.prototype.accept = function (event) {
        var _this = this;
        if (event) {
            event.target.classList.add('sym-working');
        }
        var effortFreeSlot = this.entity['EffortFreeSlot'];
        var found = false;
        var query = EntityQuery.from('DeploymentsOfDemand').expand('Resource');
        query.parameters = { oid: this.entity['Oid'] };
        query.queryOptions = new QueryOptions({ fetchStrategy: FetchStrategy.FromServer });
        this.domainService.entityManager.executeQuery(query).then(function (response) {
            // Detach deployments that do not exist any more.
            var collection = _this.entity['Deployments'];
            if (collection) {
                var i = collection.length;
                var _loop_1 = function () {
                    // Remove deleted deployments from cache.
                    i--;
                    var item = collection[i];
                    if (response.results.find(function (entity) { return item['Oid'] === entity['Oid']; }) == null) {
                        collection.splice(i, 1);
                        item.entityAspect.setDetached();
                    }
                };
                while (i > 0) {
                    _loop_1();
                }
            }
            response.results.forEach(function (deployment) {
                if (!deployment['Resource'] && deployment['Effort'] === effortFreeSlot && !found) {
                    deployment['Resource_Oid'] = _this.resourceService.getResourceOid();
                    deployment.plan(true);
                    found = true;
                }
            });
            if (found) {
                _this.domainService.saveChanges(function (error) {
                    if (error) {
                        _this.alertsService.createAlert('warning', 'APP.MARKETPLACE.DEMAND.NOT_ACCEPTED');
                    }
                    else {
                        _this.alertsService.createAlert('success', 'APP.MARKETPLACE.DEMAND.ACCEPTED');
                    }
                    _this.overlayService.closeOverlay();
                });
            }
            else {
                _this.alertsService.createAlert('warning', 'APP.MARKETPLACE.DEMAND.TAKEN');
                _this.overlayService.closeOverlay();
            }
        });
    };
    /**
     * Closes the overlay without saving
     */
    AcceptDemandComponent.prototype.cancel = function () {
        this.overlayService.closeOverlay();
    };
    return AcceptDemandComponent;
}(AbstractBase));
export { AcceptDemandComponent };
